var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventHandler, Browser, select, isNullOrUndefined } from '@syncfusion/ej2-base';
import { debounce, Touch } from '@syncfusion/ej2-base';
import { Query } from '@syncfusion/ej2-data';
export class VirtualScroll {
    constructor(parent) {
        this.sentinelInfo = {
            'up': {
                check: (rect, info) => {
                    let top = rect.top - this.containerElementRect.top;
                    info.entered = top >= 0;
                    return top + (this.parent.listItemHeight * this.parent.virtualItemCount / 2) >= 0;
                },
                axis: 'Y'
            },
            'down': {
                check: (rect, info) => {
                    let cHeight = this.parent.popupContentElement.clientHeight;
                    let top = rect.bottom;
                    info.entered = rect.bottom <= this.containerElementRect.bottom;
                    return top - (this.parent.listItemHeight * this.parent.virtualItemCount / 2) <= this.parent.listItemHeight * this.parent.virtualItemCount / 2;
                }, axis: 'Y'
            }
        };
        this.parent = parent;
        this.removeEventListener();
        this.addEventListener();
    }
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on('observe', this.observe, this);
        this.parent.on('setGeneratedData', this.setGeneratedData, this);
        this.parent.on('dataProcessAsync', this.dataProcessAsync, this);
        this.parent.on('setCurrentViewDataAsync', this.setCurrentViewDataAsync, this);
        this.parent.on('bindScrollEvent', this.bindScrollEvent, this);
    }
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off('observe', this.observe);
        this.parent.off('setGeneratedData', this.setGeneratedData);
        this.parent.off('dataProcessAsync', this.dataProcessAsync);
        this.parent.off('setCurrentViewDataAsync', this.setCurrentViewDataAsync);
        this.parent.off('bindScrollEvent', this.bindScrollEvent);
    }
    bindScrollEvent(component) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.component = component.component;
        this.observe((scrollArgs) => this.scrollListener(scrollArgs));
    }
    observe(callback) {
        this.containerElementRect = this.parent.popupContentElement.getBoundingClientRect();
        EventHandler.add(this.parent.popupContentElement, 'wheel mousedown', this.popupScrollHandler, this);
        this.touchModule = new Touch(this.parent.popupContentElement, {
            scroll: this.popupScrollHandler.bind(this)
        });
        EventHandler.add(this.parent.popupContentElement, 'scroll', this.virtualScrollHandler(callback), this);
    }
    getModuleName() {
        return 'VirtualScroll';
    }
    popupScrollHandler(e) {
        this.parent.isMouseScrollAction = true;
        this.parent.isPreventScrollAction = false;
    }
    getPageQuery(query, virtualStartIndex, virtualEndIndex) {
        if (virtualEndIndex !== 0 && !this.parent.allowFiltering && this.component !== 'autocomplete') {
            query = query.skip(virtualStartIndex);
        }
        return query;
    }
    setGeneratedData(qStartIndex, recentlyGeneratedData) {
        let loopIteration = 0;
        let endIndex = this.parent.listData.length + this.parent.virtualItemStartIndex;
        for (let i = this.parent.virtualItemStartIndex; i < endIndex; i++) {
            const alreadyAddedData = this.parent.generatedDataObject[i];
            if (!alreadyAddedData) {
                if (recentlyGeneratedData !== null && this.parent.listData.slice(loopIteration, loopIteration + 1).length > 0) {
                    const slicedData = this.parent.listData.slice(loopIteration, loopIteration + 1);
                    if (slicedData.length > 0) {
                        // Safely assign slicedData to this.parent.generatedDataObject[i]
                        this.parent.generatedDataObject[i] = slicedData;
                    }
                }
            }
            loopIteration++;
        }
    }
    generateAndExecuteQueryAsync(query, virtualItemStartIndex = 0, virtualItemEndIndex = 0, isQueryGenerated = false) {
        let dataSource = this.parent.dataSource;
        if (!isQueryGenerated) {
            query = this.getPageQuery(query, virtualItemStartIndex, virtualItemEndIndex);
        }
        this.parent.resetList(dataSource, this.parent.fields, query);
    }
    setCurrentViewDataAsync() {
        // eslint-disable-next-line
        let currentData = [];
        for (let i = this.parent.viewPortInfo.startIndex; i < this.parent.viewPortInfo.endIndex; i++) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const alreadyAddedData = this.parent.generatedDataObject[i];
            if (alreadyAddedData) {
                currentData.push(alreadyAddedData[0]);
            }
        }
        this.parent.renderItems(currentData, this.parent.fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const virtualTrackElement = this.parent.list.getElementsByClassName('e-virtual-ddl')[0];
        if (virtualTrackElement) {
            (virtualTrackElement).style = this.parent.GetVirtualTrackHeight();
        }
        this.parent.UpdateSkeleton();
        this.parent.liCollections = this.parent.list.querySelectorAll('.e-list-item');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const virtualContentElement = this.parent.list.getElementsByClassName('e-virtual-ddl-content')[0];
        if (virtualContentElement) {
            (virtualContentElement).style = this.parent.getTransformValues();
        }
    }
    generateQueryAndSetQueryIndexAsync(query, isPopupOpen) {
        let isStartIndexInitialised = false;
        let queryStartIndex = 0;
        let queryEndIndex = 0;
        let sortedDataStartIndex = 0;
        let vEndIndex = this.parent && this.parent.viewPortInfo.endIndex !== 0 ? this.parent.viewPortInfo.endIndex : sortedDataStartIndex + this.parent.getItems().length;
        if (!isPopupOpen && vEndIndex !== 0) {
            for (let i = this.parent.viewPortInfo.startIndex; i <= vEndIndex; i++) {
                if (!(i in this.parent.generatedDataObject)) {
                    if (!isStartIndexInitialised) {
                        isStartIndexInitialised = true;
                        queryStartIndex = queryEndIndex = i;
                    }
                    else {
                        queryEndIndex = i === vEndIndex ? i : i + 1;
                    }
                }
            }
        }
        if (isStartIndexInitialised && !((this.parent.totalItemCount == queryStartIndex) && (this.parent.totalItemCount == queryEndIndex))) {
            this.parent.virtualItemStartIndex = queryStartIndex;
            this.parent.virtualItemEndIndex = queryEndIndex;
            this.generateAndExecuteQueryAsync(query, queryStartIndex, queryEndIndex);
        }
        this.setCurrentViewDataAsync();
    }
    dataProcessAsync(isOpenPopup) {
        this.parent.selectedValueInfo = null;
        this.parent.virtualItemStartIndex = this.parent.viewPortInfo.startIndex;
        this.parent.virtualItemEndIndex = this.parent.viewPortInfo.endIndex;
        this.generateQueryAndSetQueryIndexAsync(new Query(), isOpenPopup);
    }
    virtualScrollRefreshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.parent.isCustomFilter = (!(this.parent.isTyped || (this.component === 'combobox' && this.parent.allowFiltering && this.parent.queryString != this.parent.typedString) || (!isNullOrUndefined(this.parent.filterInput) && !isNullOrUndefined(this.parent.filterInput.value) && this.parent.filterInput.value !== '') && this.component !== 'combobox') && !(this.component === 'autocomplete' && this.parent.value != null)) || this.parent.isCustomFilter;
            if (this.parent.allowFiltering || this.component === 'autocomplete') {
                if (!isNullOrUndefined(this.parent.typedString) && !(this.component === 'combobox' && !isNullOrUndefined(this.parent.typedString) && this.parent.allowFiltering)) {
                    if (this.parent.viewPortInfo.endIndex >= this.parent.dataCount) {
                        this.parent.viewPortInfo.endIndex = this.parent.dataCount;
                    }
                    if (this.parent.viewPortInfo.startIndex >= this.parent.dataCount) {
                        this.parent.viewPortInfo.startIndex = this.parent.dataCount - this.parent.itemCount;
                    }
                }
                else {
                    this.parent.getSkeletonCount(true);
                }
            }
            yield this.dataProcessAsync();
            if (this.parent.keyboardEvent != null) {
                this.parent.handleVirtualKeyboardActions(this.parent.keyboardEvent, this.parent.pageCount);
            }
            this.parent.isCustomFilter = false;
        });
    }
    scrollListener(scrollArgs) {
        if (!this.parent.isPreventScrollAction) {
            let info = scrollArgs.sentinel;
            let pStartIndex = this.parent.previousStartIndex;
            this.parent.viewPortInfo = this.getInfoFromView(scrollArgs.direction, info, scrollArgs.offset, false);
            this.parent.isUpwardScrolling = false;
            if (this.parent.previousStartIndex !== pStartIndex && !this.parent.isKeyBoardAction) {
                this.parent.isScrollActionTriggered = false;
                this.parent.currentPageNumber = this.parent.viewPortInfo.currentPageNumber;
                this.parent.virtualListInfo = Object.assign({}, this.parent.viewPortInfo);
                this.parent.isPreventKeyAction = true;
                this.parent.isVirtualScrolling = true;
                setTimeout(() => {
                    this.parent.pageCount = this.parent.getPageCount();
                    this.virtualScrollRefreshAsync().then(() => {
                        if (this.parent.popupObj) {
                            this.parent.list = this.parent.popupObj.element.querySelector('.' + 'e-content') || select('.' + 'e-content');
                            this.parent.updateSelectionList();
                            this.parent.liCollections = this.parent.getItems();
                        }
                        this.parent.isKeyBoardAction = false;
                        this.parent.isVirtualScrolling = false;
                        this.parent.isPreventKeyAction = false;
                    });
                }, 5);
            }
            else if (this.parent.isScrollActionTriggered) {
                this.parent.isPreventKeyAction = false;
                this.parent.isScrollActionTriggered = false;
                let virtualListCount = this.parent.list.querySelectorAll('.e-virtual-list').length;
                let listElement = this.parent.list.querySelector('.' + 'e-list-item');
                let translateY = scrollArgs.offset.top - (listElement.offsetHeight * virtualListCount);
                this.parent.list.getElementsByClassName('e-virtual-ddl-content')[0].style.transform = "translate(0px," + translateY + "px)";
            }
            this.parent.previousInfo = this.parent.viewPortInfo;
        }
    }
    getPageCount(popupElement, returnExactCount = false) {
        var list = popupElement && popupElement.querySelector('.e-content');
        if (list) {
            var liHeight = list.classList.contains('e-nodata') ? null : getComputedStyle(list.querySelectorAll('.e-list-item')[0], null).getPropertyValue('height');
            var pageCount = list.getBoundingClientRect().height / parseInt(liHeight, 10);
            return returnExactCount ? pageCount : Math.round(pageCount);
        }
        return 0;
    }
    ;
    getRowHeight() {
        return (isNullOrUndefined(this.parent.liCollections) || this.parent.liCollections.length == 0) ? 0 : Math.ceil(this.parent.liCollections[0].getBoundingClientRect().height);
    }
    getInfoFromView(direction, info, e, isscrollAction) {
        let infoType = {
            direction: direction, sentinelInfo: info, offsets: e,
            startIndex: this.parent.previousStartIndex, endIndex: this.parent.previousEndIndex
        };
        let vHeight = this.parent.popupContentElement.getBoundingClientRect().height;
        //Row Start and End Index calculation
        let rowHeight = this.parent.listItemHeight;
        let exactTopIndex = e.top / rowHeight;
        let infoViewIndices = vHeight / rowHeight;
        let exactEndIndex = exactTopIndex + infoViewIndices;
        let pageSizeBy4 = this.parent.virtualItemCount / 4;
        let totalItemCount = this.parent.totalItemCount;
        if (infoType.direction === 'down') {
            let sIndex = Math.round(exactEndIndex) - Math.round((pageSizeBy4));
            if (isNullOrUndefined(infoType.startIndex) || (exactEndIndex >
                (infoType.startIndex + Math.round((this.parent.virtualItemCount / 2 + pageSizeBy4)))
                && infoType.endIndex !== totalItemCount)) {
                infoType.startIndex = sIndex >= 0 ? Math.round(sIndex) : 0;
                infoType.startIndex = infoType.startIndex > exactTopIndex ? Math.floor(exactTopIndex) : infoType.startIndex;
                let eIndex = infoType.startIndex + this.parent.virtualItemCount;
                infoType.startIndex = eIndex < exactEndIndex ? (Math.ceil(exactEndIndex) - this.parent.virtualItemCount)
                    : infoType.startIndex;
                infoType.endIndex = eIndex < totalItemCount ? eIndex : totalItemCount;
                infoType.startIndex = eIndex >= totalItemCount ? (infoType.endIndex - this.parent.virtualItemCount > 0 ? infoType.endIndex - this.parent.virtualItemCount : 0) : infoType.startIndex;
                infoType.currentPageNumber = Math.ceil(infoType.endIndex / this.parent.virtualItemCount);
            }
        }
        else if (infoType.direction === 'up') {
            if (infoType.startIndex && infoType.endIndex) {
                let loadAtIndex = Math.round(((infoType.startIndex * rowHeight) + (pageSizeBy4 * rowHeight)) / rowHeight);
                if (exactTopIndex < loadAtIndex) {
                    let idxAddedToExactTop = (pageSizeBy4) > infoViewIndices ? pageSizeBy4 :
                        (infoViewIndices + infoViewIndices / 4);
                    let eIndex = Math.round(exactTopIndex + idxAddedToExactTop);
                    infoType.endIndex = eIndex < totalItemCount ? eIndex : totalItemCount;
                    let sIndex = infoType.endIndex - this.parent.virtualItemCount;
                    infoType.startIndex = sIndex > 0 ? sIndex : 0;
                    infoType.endIndex = sIndex < 0 ? this.parent.virtualItemCount : infoType.endIndex;
                    infoType.currentPageNumber = Math.ceil(infoType.startIndex / this.parent.virtualItemCount);
                }
            }
        }
        if (!isscrollAction) {
            this.parent.previousStartIndex = infoType.startIndex;
            this.parent.startIndex = infoType.startIndex;
            this.parent.previousEndIndex = infoType.endIndex;
        }
        else {
            this.parent.scrollPreStartIndex = infoType.startIndex;
        }
        return infoType;
    }
    virtualScrollHandler(callback) {
        let delay = Browser.info.name === 'chrome' ? 200 : 100;
        let prevTop = 0;
        let debounced100 = debounce(callback, delay);
        let debounced50 = debounce(callback, 50);
        return (e) => {
            let top = e.target.scrollTop;
            let left = e.target.scrollLeft;
            let direction = prevTop < top && !this.parent.isUpwardScrolling ? 'down' : 'up';
            prevTop = top;
            let current = this.sentinelInfo[direction];
            var pstartIndex = this.parent.scrollPreStartIndex;
            var scrollOffsetargs = {
                top: top,
                left: left
            };
            if (this.parent.list.querySelectorAll('.e-virtual-list').length > 0) {
                var infoview = this.getInfoFromView(direction, current, scrollOffsetargs, true);
                if (this.parent.scrollPreStartIndex != pstartIndex && !this.parent.isPreventScrollAction) {
                    this.parent.isScrollActionTriggered = true;
                    let virtualPoup = (this.parent.list.querySelector('.e-virtual-ddl-content'));
                    virtualPoup.style.transform = "translate(0px," + top + "px)";
                }
            }
            let debounceFunction = debounced100;
            if (current.axis === 'X') {
                debounceFunction = debounced50;
            }
            debounceFunction({ direction: direction, sentinel: current, offset: { top: top, left: left },
                focusElement: document.activeElement });
        };
    }
    destroy() {
        this.removeEventListener();
    }
}
